// extracted by mini-css-extract-plugin
export default {"errorDisplay":"ErrorPage_errorDisplay__Kjwqz","errorTitle":"ErrorPage_errorTitle__rsSMj"};